import { Reservations } from '@lib/state/api';

export type CorporateInvoice = Reservations.InvoiceModel;
export type InvoiceType = Reservations.InvoiceType;
export const InvoiceType = Reservations.InvoiceType;

export type RegenerateInvoicesRequest = Reservations.RegenerateInvoiceRequest;
